import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import AppModel from '../DataModel/AppModel';

import {ListItem} from 'material-ui/List';

import CircularProgress from 'material-ui/CircularProgress';
import Machine from 'material-ui/svg-icons/action/settings-remote';
import Avatar from 'material-ui/Avatar';
import {blue500} from 'material-ui/styles/colors';

import moment from 'moment-timezone';

export default
@observer class MachineListElement extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  // Goto detail page for machine :
  gotoDetail() {
    var machine = this.props.machine;
    this.context.router.push('/machines/machine/'+machine.id);
  }

  infoLine(m) {
    if(m.isJobRunning) {
      return uiMsg('ML_JOB_RUNNING',"Currently running disinfection job.  Job started at ")+
        moment(m.last_job.start_time).tz(AppModel.time_zone)
        .locale(AppModel.locale).format("LLL");
    }
    else {
      if(!m.last_job) return uiMsg('ML_NO_LAST_JOB',"No last job registered");
      return uiMsg('ML_LAST_JOB_COMPLETED',"Last job completed at <X>",moment(m.last_job.end_time)
      .tz(AppModel.time_zone).locale(AppModel.locale).format("LLL"));
    }
  }

  render() {
    var machine = this.props.machine;
    return (
      <ListItem
          value={machine}
          leftAvatar={<Avatar icon={<Machine />}
          backgroundColor={blue500} />}
          primaryText={machine.name + " ("+machine.id+")"}
          secondaryText={this.infoLine(machine)}
          onTouchTap={this.gotoDetail.bind(this)}
      />
    )
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/MachineListElement.jsx
 **/